import { createAction } from 'redux-act';
//////////////////////////////////////////////////
export * from './config-pages/ui/actions';
export * from './config-pages/clo/actions';
export * from './config-pages/tel/actions';
export * from './config-pages/driver/actions';
export * from './config-pages/rating/actions';
export * from './config-pages/carrier/actions';
export * from './config-pages/general/actions';
export * from './config-pages/invoice/actions';
export * from './config-pages/integration/actions';
export * from './config-pages/communication/actions';
export * from './config-pages/task-management/actions';
//////////////////////////////////////////////////

export const getSequencesByTypeForConfigRequest = createAction(
  'getSequencesByTypeForConfigRequest',
);
export const getSequencesByTypeForConfigSuccess = createAction(
  'getSequencesByTypeForConfigSuccess',
);
export const cleanConfigState = createAction('cleanConfigState');
export const getReferenceTypesGuidsNamesMapRequest = createAction(
  'getReferenceTypesGuidsNamesMapRequest',
);
export const getReferenceTypesGuidsNamesMapSuccess = createAction(
  'getReferenceTypesGuidsNamesMapSuccess',
);
export const getReferenceTypesByScopeForConfigRequest = createAction(
  'getReferenceTypesByScopeForConfigRequest',
);
export const getReferenceTypesByScopeForConfigSuccess = createAction(
  'getReferenceTypesByScopeForConfigSuccess',
);
export const setConfigWarning = createAction('setConfigWarning');
export const setConfigTabsVisited = createAction('setConfigTabsVisited');
export const updateConfigsSuccess = createAction('updateConfigsSuccess');
export const updateConfigsRequest = createAction('updateConfigsRequest');
export const getStatusCodeListSuccess = createAction('getStatusCodeList');
export const getStatusCodeListRequest = createAction('getStatusCodeList');
export const getConfigByGroupSuccess = createAction('getConfigByGroupSuccess');
export const getConfigByGroupRequest = createAction('getConfigByGroupRequest');
export const setAvailableLocationTypes = createAction('setAvailableLocationTypes');
export const getAvailableDocumentTypes = createAction('getAvailableDocumentTypes');
export const connectToFinancialSuccess = createAction('connectToFinancialSuccess');
export const connectToAccountingRequest = createAction('connectToAccountingRequest');
export const setActiveConfigGroupWithTab = createAction('setActiveConfigGroupWithTab');
export const removeOptionalConfigRequest = createAction('removeOptionalConfigRequest');
export const getGroupConfigsByNamesRequest = createAction('getGroupConfigsByNamesRequest');
export const getGroupConfigsByNamesSuccess = createAction('getGroupConfigsByNamesSuccess');
export const getSequencesGuidNameMapRequest = createAction('getSequencesGuidNameMapRequest');
export const getSequencesGuidNameMapSuccess = createAction('getSequencesGuidNameMapSuccess');
export const disconnectFromFinancialSuccess = createAction('disconnectFromFinancialSuccess');
export const getConfigsForAuthWrapperRequest = createAction('getConfigsForAuthWrapperRequest');
export const disconnectFromAccountingRequest = createAction('disconnectFromAccountingRequest');
export const restoreInheritedDropdownRequest = createAction('restoreInheritedDropdownRequest');
export const restoreInheritedByConfigTypeRequest = createAction('restoreInheritedByConfigTypeRequest');
export const receivedAvailableDocumentTypesSuccess = createAction('receivedAvailableDocumentTypesSuccess');
// DISPATCH BOARD ACTION PANEL
export const getCloDispatchBoardActionListRequest = createAction('getCloDispatchBoardActionListRequest');
export const getCloDispatchBoardActionListSuccess = createAction('getCloDispatchBoardActionListSuccess');
export const getTelDispatchBoardActionListRequest = createAction('getTelDispatchBoardActionListRequest');
export const getTelDispatchBoardActionListSuccess = createAction('getTelDispatchBoardActionListSuccess');
export const saveDispatchBoardStatusActionRequest = createAction('saveDispatchBoardStatusActionRequest');
export const updateDispatchBoardStatusActionRequest = createAction('updateDispatchBoardStatusActionRequest');
export const deleteDispatchBoardStatusActionRequest = createAction('deleteDispatchBoardStatusActionRequest');
export const getCentralizedDispatchActionListRequest = createAction('getCentralizedDispatchActionListRequest');
export const getCentralizedDispatchActionListSuccess = createAction('getCentralizedDispatchActionListSuccess');
// terms and conditions
export const getTermsAndConditionsDocumentRequest = createAction('getTermsAndConditionsDocumentRequest');
export const getTermsAndConditionsDocumentSuccess = createAction('getTermsAndConditionsDocumentSuccess');
export const removeTermsAndConditionsDocumentRequest = createAction('removeTermsAndConditionsDocumentRequest');
export const createTermsAndConditionsDocumentRequest = createAction('createTermsAndConditionsDocumentRequest');
export const updateTermsAndConditionsDocumentRequest = createAction('updateTermsAndConditionsDocumentRequest');
// transportation mode config mapping
export const removeTransportationModeConfigMappingRequest =
  createAction('removeTransportationModeConfigMappingRequest');
export const removeTransportationModeConfigMappingSuccess =
  createAction('removeTransportationModeConfigMappingSuccess');
export const getTransportationModeConfigMappingListRequest =
  createAction('getTransportationModeConfigMappingListRequest');
export const getTransportationModeConfigMappingListSuccess =
  createAction('getTransportationModeConfigMappingListSuccess');
export const createOrUpdateTransportationModeConfigMappingRequest =
  createAction('createOrUpdateTransportationModeConfigMappingRequest');
export const createOrUpdateTransportationModeConfigMappingSuccess =
  createAction('createOrUpdateTransportationModeConfigMappingSuccess');
// dropdown option config
export const removeDropdownOptionConfigRequest = createAction('removeDropdownOptionConfigRequest');
export const removeDropdownOptionConfigSuccess = createAction('removeDropdownOptionConfigSuccess');
export const createOrUpdateDropdownOptionConfigRequest = createAction('createOrUpdateDropdownOptionConfigRequest');
export const createOrUpdateDropdownOptionConfigSuccess = createAction('createOrUpdateDropdownOptionConfigSuccess');
// equipment service auto create
export const setServiceTypeOptions = createAction('setServiceTypeOptions');
export const setServiceVendorOptions = createAction('setServiceVendorOptions');
export const removeEquipmentServiceAutoCreateConfigRequest =
  createAction('removeEquipmentServiceAutoCreateConfigRequest');
export const removeEquipmentServiceAutoCreateConfigSuccess =
  createAction('removeEquipmentServiceAutoCreateConfigSuccess');
export const getEquipmentServiceAutoCreateConfigListRequest =
  createAction('getEquipmentServiceAutoCreateConfigListRequest');
export const getEquipmentServiceAutoCreateConfigListSuccess =
  createAction('getEquipmentServiceAutoCreateConfigListSuccess');
export const createOrUpdateEquipmentServiceAutoCreateConfigRequest =
  createAction('createOrUpdateEquipmentServiceAutoCreateConfigRequest');
export const createOrUpdateEquipmentServiceAutoCreateConfigSuccess =
  createAction('createOrUpdateEquipmentServiceAutoCreateConfigSuccess');
// geofencing zone color config
export const getGeofencingZoneColorConfigRequest = createAction('getGeofencingZoneColorConfigRequest');
export const getGeofencingZoneColorConfigSuccess = createAction('getGeofencingZoneColorConfigSuccess');
export const deleteGeofencingZoneColorConfigRequest = createAction('deleteGeofencingZoneColorConfigRequest');
export const createOrUpdateGeofencingZoneColorConfigRequest =
  createAction('createOrUpdateGeofencingZoneColorConfigRequest');
